module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "save-on-enter": ""
    },
    on: {
      "save": _vm.reassignAll
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "15px",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('UserChooser', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "contact": _vm.fromUser,
      "contacts": _vm.users,
      "label": "Assign From"
    },
    on: {
      "select": _vm.loadTasksForUser
    },
    model: {
      value: (_vm.fromUser),
      callback: function($$v) {
        _vm.fromUser = $$v
      },
      expression: "fromUser"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('UserChooser', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "contact": _vm.toUser,
      "contacts": _vm.users,
      "label": "Reassign To"
    },
    on: {
      "select": function($event) {
        _vm.hasDestination = true
      }
    },
    model: {
      value: (_vm.toUser),
      callback: function($$v) {
        _vm.toUser = $$v
      },
      expression: "toUser"
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v("For the next " + _vm._s(_vm.days) + " days")]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 0,
      "max": 28
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#999"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tasks.length) + " tasks\n            ")])], 1), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": _vm.tasks.length == 0
    },
    on: {
      "click": _vm.reassign
    }
  }, [_vm._v("Assign")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f404ce5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ReassignTasksDialog.vue
// module id = 2540
// module chunks = 1